exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only{display:none !important}}@media (max-width: 1023px){.desktop-only{display:none !important}}body{--overlay-z-index: 1;--sidebar-aside-z-index: 2;--sidebar-z-index: 2;--bottom-navigation-height: 3.75rem;--bar-height: 3.125rem;--notification-font-size: var(--font-sm);font-family:var(--font-family-secondary);margin:0;padding:0}body a{text-decoration:none;color:var(--c-link);cursor:pointer}body a:hover{color:var(--c-link-hover)}#viewport{position:relative}@media (min-width: 1024px){.sidebar__microcart{--sidebar-aside-width: 700px}}\n", ""]);

// exports
